const settings = {
	stopnja_ddv: 22,
	dbDtFormat: 'YYYY-MM-DD HH:mm:ss',
	dbDFormat: 'YYYY-MM-DD',
	inputDtFormat: 'YYYY-MM-DD',
	viewDtFormat: 'DD. MM. YYYY',
	viewTimeFormat: 'HH:mm',
	hrsDtFormat: 'DD.MM.YYYY HH:mm',
	hrsDFormat: 'DD.MM.YYYY',
	vozilaImportDFormat: 'M/D/YYYY',
	isProdajalec: function (role) {
		return role === 0; // prodajalec
	},
	isSekretar: function (role) {
		return role === 1; // komercialni sekretar
	},
	isRacunovodja: function (role) {
		return role === 3; // racunovodja
	},
	isModerator: function (role) {
		return role === 4; // moderator
	},
	isAdmin: function (role) {
		return role === 5; // admin
	},
	isSkrbnikGum: function (role) {
		return role === 11; // skrbnik gum
	},
	isGledalecGum: function (role) {
		return role === 12; // gledalec gum
	},
	isPoprodaja: function (role) {
		return role === 13; // poprodaja
	},
	highPermissionsRoles: [4, 5],
	vozilaRoles: [0, 1, 3],
	hotelGumRoles: [11, 12],
	poprodajaRoles: [13],
	errorMessages: {
		'serverSideValidationError': 'serverSideValidationError',
		'notSavedError': 'notSavedError',
		'PDOException': 'PDOException',
		'unknownRole': 'unknownRole',
		'invalidRole': 'invalidRole'
	},
	filterTimeoutLength: 1000,
	responseTimeout: 15000,
	tiresDimensions: {
		width_options: [
			'4',
			'7',
			'9',
			'12',
			'60',
			'80',
			'90',
			'100',
			'110',
			'120',
			'130',
			'135',
			'140',
			'145',
			'150',
			'155',
			'160',
			'165',
			'170',
			'175',
			'180',
			'190',
			'195',
			'205',
			'215',
			'225',
			'235',
			'245',
			'255',
			'255',
			'275',
			'285',
			'295',
			'315',
			'320',
			'500'
		],
		heigth_options: [
			'30',
			'35',
			'40',
			'45',
			'50',
			'55',
			'60',
			'65',
			'70',
			'75',
			'80',
			'85',
			'90',
			'100'
		],
		diameter_options: [
			'10',
			'12',
			'13',
			'14',
			'15',
			'16',
			'17',
			'18',
			'19',
			'20',
			'21'
		]
	},
	season_options: [
		{ text: 'Letne', value: 'L' },
		{ text: 'Zimske', value: 'Z' },
		{ text: 'Celoletne', value: 'ZL' }
	],
	rims_options: [
		{ text: 'Brez', value: 'BREZ' },
		{ text: 'ALU platišča', value: 'ALU' },
		{ text: 'FE platišča', value: 'FE' }
	],
	vehicle_models: [
		{ icon: 'logo_tz.png', value: 'tz', label: 'Tuja znamka' },
		{ icon: 'logo_renault.png', value: 'renault', label: 'Renault' },
		{ icon: 'logo_nissan.png', value: 'nissan', label: 'Nissan' },
		{ icon: 'logo_kia.png', value: 'kia', label: 'Kia' },
		{ icon: 'logo_toyota.png', value: 'toyota', label: 'Toyota' },
		{ icon: 'logo_dacia.png', value: 'dacia', label: 'Dacia' },
		{ icon: 'logo_mg.png', value: 'mg', label: 'MG' }
	],
	cdp_vehicle_stock_kind: [
		{ variant: 'success', value: 'Novo vozilo', label: 'N' },
		{ variant: 'warning', value: 'Testno vozilo', label: 'T' },
		{ variant: 'danger', value: 'Rabljeno vozilo', label: 'R' },
	],
	cdp_vehicle_stock_paid_options: [
		{ variant: 'success', value: 'paid_at_not_null', label: 'Plačano' },
		{ variant: 'primary', value: 'paid_at_null', label: 'Čaka na plačilo' },
	],
}
export default settings



// WEBPACK FOOTER //
// ./src/settings.js